import { push } from 'connected-react-router';

export default function transitionTo(route) {
  return dispatch => {
    dispatch(push(route));
  };
}
